import algoliasearch from 'algoliasearch/lite';
import { formatedDate, truncateString, locale } from '../alpine-functions';
import { CREDENTIALS as AlgoliaCredantials } from '../config/algolia';

const LIMIT = 3;
const BASE_URL = '/api/collections/blog_posts/entries';
const FIELDS = 'url,title,perex,hero_image,date';
const ASSET_API = '/api/v1/assets';

export default (searchEnabled = false) => ({
  posts: [],
  searchEnabled: searchEnabled,
  indexBlogPosts: {},
  searching: false,
  currentUrl: window.location.pathname,
  locale: locale(),

  get algoliaClient() {
    return algoliasearch(AlgoliaCredantials.app, AlgoliaCredantials.key);
  },

  init() {
    if (this.searchEnabled) {
      return this.initAlgoliaIndex('BLOG_POSTS');
    }
    return this.getPosts();
  },

  initAlgoliaIndex(index) {
    this.indexBlogPosts = this.algoliaClient.initIndex(index);
  },

  getPosts() {
    fetch(
      `${BASE_URL}?limit=${LIMIT}&fields=${FIELDS}&sort=-date&filter[url:not]=${this.currentUrl}&filter[site:is]=${this.locale}`
    )
      .then((response) => response.json())
      .then((response) => {
        this.posts = response.data;
      });
  },

  hasPosts() {
    return this.posts.length > 0;
  },

  formatedDate(date) {
    return formatedDate(date);
  },

  getHeroImage(post) {
    const http = new XMLHttpRequest();

    http.open('HEAD', post.hero_image_cached_path, false);
    http.send();

    if (http.status != 404) {
      return post.hero_image_cached_path;
    }

    return `${ASSET_API}?id=${post.hero_image_id}`;
  },

  getPerex(perex = '') {
    return truncateString(perex, 123);
  },

  searchQuery(filter) {
    if (filter.query.length < 3 && !filter.tags.length) {
      this.searching = false;
      return (this.posts = []);
    }

    this.searching = true;

    this.indexBlogPosts.search(filter.query).then(({ hits }) => {
      if (filter.tags.length > 0) {
        this.posts = hits.filter((item) => {
          return item.tags
            ? item.tags.filter((x) => filter.tags.includes(`tags::${x}`)).length
            : false;
        });
      } else {
        this.posts = hits;
      }
    });
  },
});
